<template>
  <div
    :class="[
      'c-project-status-badge d-inline-flex px-2 py-1 rounded-5',
      'is-' + status.status,
    ]"
  >
    <img
      src="@/assets/icons/green-circle.svg"
      v-if="status.active"
      class="mr-2"
    />
    <span class="p-12-b display-status">{{ status.displayStatus }}</span>
  </div>
</template>

<script>
export default {
  props: ["status"],
};
</script>

<style lang="scss" scoped>
.c-project-status-badge {
  border: 1px solid var(--lightgray);
  background: var(--fog);
  .display-status {
    color: var(--gray);
  }
  &.is-live {
    border: 1px solid var(--green);
    background: rgba(74, 216, 152, 0.1);
    .display-status {
      color: var(--green);
    }
  }
}
</style>